import React from "react"
import { ModalProps } from "./index"
import * as s from "./styles"

const parseContent = (
    content:
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | Iterable<React.ReactNode>
        | React.ReactPortal
        | boolean
) => {
    if (!content) return null

    if (typeof content === "string") {
        const parts = content.split(/(<b>.*?<\/b>|<br>|<i>.*?<\/i>|<small>.*?<\/small>)/)
        return parts.map((part: string, index: React.Key | null | undefined) => {
            if (part.startsWith("<b>") && part.endsWith("</b>")) {
                return <strong key={index}>{part.slice(3, -4)}</strong>
            } else if (part === "<br>") {
                return <span style={s.brSpacer} key={index}></span>
            } else if (part.startsWith("<i>") && part.endsWith("</i>")) {
                return <i key={index}>{part.slice(3, -4)}</i>
            } else if (part.startsWith("<small>") && part.endsWith("</small>")) {
                return <small key={index}>{part.slice(7, -8)}</small>
            }
            return part
        })
    } else {
        return content
    }
}

const Confirm: React.FC<ModalProps> = ({ open, close, onCancel, onOk, title, content }) => {
    if (!open) return null

    return (
        <div
            data-test="confirm"
            style={s.overlay}
            onClick={() => {
                close()
                onCancel?.()
            }}
        >
            <div style={s.confirmCard} onClick={(e) => e.stopPropagation()}>
                {title && (
                    <div data-test="confirm__title" style={s.confirmTitle}>
                        {title}
                    </div>
                )}

                {content && (
                    <div data-test="confirm__content" style={s.confirmContent}>
                        {parseContent(content)}
                    </div>
                )}

                <div style={s.confirmButtonRow}>
                    <button
                        data-test="confirm__cancel-button"
                        onClick={() => {
                            close()
                            onCancel?.()
                        }}
                        style={s.cancelButton}
                    >
                        Cancel
                    </button>
                    <button
                        data-test="confirm__ok-button"
                        onClick={() => {
                            close()
                            onOk?.()
                        }}
                        style={s.okButton}
                    >
                        Ok
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Confirm
